import { Helmet } from 'react-helmet-async';
import { siteUrl } from '../lib/siteUrl';

type Props = {
  title: string;
  description: string;
  datePublished: string;
  path: string;
};

export function JsonLdBlogPost({ title, description, datePublished, path }: Props) {
  const p = path.startsWith('/') ? path : `/${path}`;
  const url = `${siteUrl()}${p}`;
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    datePublished,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
